/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_act_very = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very active (hard exercise / physical job)`)
};

const es_bmr_act_very = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muy activo (ejercicio intenso / trabajo físico)`)
};

const de_bmr_act_very = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehr aktiv (intensives Training / körperlich anstrengende Arbeit)`)
};

const nl_bmr_act_very = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeer actief (intens oefenen / fysiek werk)`)
};

const fr_bmr_act_very = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Très actif (exercice intense / travail physique)`)
};

const it_bmr_act_very = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molto attivo (esercizio intenso / lavoro fisico)`)
};

const pt_br2_bmr_act_very = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muito ativo (exercício intenso / trabalho físico)`)
};

const pt_bmr_act_very = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muito ativo (exercício intenso / trabalho físico)`)
};

const ja_bmr_act_very = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常に活発（厳しい運動/肉体労働）`)
};

const zh_bmr_act_very = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常活跃（高强度运动/体力劳动工作）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_act_very = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_act_very(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_act_very", locale)
	if (locale === "en") return en_bmr_act_very(inputs)
	if (locale === "es") return es_bmr_act_very(inputs)
	if (locale === "de") return de_bmr_act_very(inputs)
	if (locale === "nl") return nl_bmr_act_very(inputs)
	if (locale === "fr") return fr_bmr_act_very(inputs)
	if (locale === "it") return it_bmr_act_very(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_act_very(inputs)
	if (locale === "pt") return pt_bmr_act_very(inputs)
	if (locale === "ja") return ja_bmr_act_very(inputs)
	return zh_bmr_act_very(inputs)
};